/* ============================================================
   labels.js — product card/PDP label ("BESTSELLER" etc.) matching,
   driven entirely by window.GhoncheLabelBlocks (Theme Editor blocks on
   the header section, product/collection picker - no metafields, no
   metaobjects). Same pattern as ratings.js: a data-badge-proof hook
   left by the Liquid markup, filled in here once, on every page it
   appears (cards, PDP), matched by product handle or collection
   handle - never editable from a product's own Admin page.
   ============================================================ */
(function () {
  "use strict";

  function findLabelFor(handle, collections) {
    var blocks = window.GhoncheLabelBlocks || [];
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (b.handles && b.handles.indexOf(handle) !== -1) return b;
      if (b.collection && collections.indexOf(b.collection) !== -1) return b;
    }
    return null;
  }

  function applyLabels(root) {
    (root || document).querySelectorAll("[data-badge-proof]").forEach(function (el) {
      var scope = el.closest("[data-product-handle]");
      if (!scope) return;
      var handle = scope.getAttribute("data-product-handle");
      var collections = (scope.getAttribute("data-collections") || "").split(",").filter(Boolean);
      var label = findLabelFor(handle, collections);
      if (!label) return; // no match - leave the server-rendered fallback (or hidden) as-is
      el.textContent = label.text;
      el.style.background = label.color || "";
      el.hidden = false;
    });
  }

  document.addEventListener("DOMContentLoaded", function () { applyLabels(); });
  if (document.readyState !== "loading") applyLabels();

  /* Re-apply after Shopify section re-renders in the theme editor. */
  document.addEventListener("shopify:section:load", function (e) { applyLabels(e.target); });
})();
